import { useFreshworksWidget } from "components/common/Freshworks/useFreshworksWidget";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { Translate } from "components/common/Translate/Translate";

interface ContactUsProps {
    title: string;
}

const ContactUsElement = ({ title }: ContactUsProps) => {
    const { openFreshworksWidget } = useFreshworksWidget();
    return (
        <li
            onClick={(e) => {
                e.preventDefault();
                openFreshworksWidget();
            }}
            className="cursor-pointer"
        >
            <Translate keyName={title} />
        </li>
    );
};

export const ContactUs = (props: ContactUsProps) => {
    return (
        <ReduxProvider>
            <ContactUsElement {...props} />
        </ReduxProvider>
    );
};
